import React, { useEffect, useState } from "react";
import Footer from "../components/footer";
import Navbar from "../components/navbar";
import { useSelectOrganization } from "../hooks/selectOrganization";
import { useAuth } from "../services/authProvider";
import {jwtDecode} from 'jwt-decode';

const Organization = (props) => {
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrganization, setSelectedOrganization] = useState("");
  const { mutate: selectOrganization, isPending, isLoading, data } = useSelectOrganization();
  const { updateToken } = useAuth();

  useEffect(() => {
    // Get organizations from the token
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      const userInfo = jwtDecode(accessToken);
      if (userInfo.organizations && userInfo.organizations.length > 0) {
        setOrganizations(userInfo.organizations);
      }
    }
  }, []);

  const handleSelected = (organization) => {
    setSelectedOrganization(organization.id);
    selectOrganization(organization.id);
  };

  useEffect(() => {
    if (data?.status === 200 && !isLoading) {
      // Update the token with the new organization selection
      updateToken(data.data.token);

      // Navigate to role selection
      props.history.push("/user/role");
    }
  }, [data, isLoading, updateToken, props.history]);

  return (
    <div className="d-flex flex-column h_100">
      <Navbar isPageRole={true} />
      <div className="main">
        <div className="col-lg-4">
          <div className="card border-0 shadow sm">
            <div className="card-body p-5">
              <h4 className="text-center mb-5">Select Organization</h4>
              {organizations.length > 0 ? (
                organizations.map((org, key) => (
                  <button
                    key={key}
                    onClick={() => handleSelected(org)}
                    className={`btn btn-block hoverActive my-4 py-2 shadow ${
                      selectedOrganization === org.id && "btn_active"
                    }`}
                    disabled={isPending}
                  >
                    <small>{org.name}</small>
                  </button>
                ))
              ) : (
                <p className="text-center">No organizations available</p>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Organization;
